import { Menu, X } from "lucide-react";
import { useState } from "react";
import EmergencyAnnouncementBar from "@/components/EmergencyAnnouncementBar";

const links = [
  { label: "ABOUT INSTRUCTOR", href: "#about", testId: "nav-link-about-instructor" },
  { label: "GROUP CLASSES", href: "#group-practice", testId: "nav-link-group-classes" },
  { label: "1-ON-1 LESSONS", href: "#private-lesson", testId: "nav-link-one-on-one" },
  { label: "PRICING & OFFERS", href: "/special-offers", testId: "nav-link-pricing-offers" },
  { label: "Let's Chat", href: "#contact", testId: "nav-link-lets-chat" },
  { label: "FAQ", href: "#faq", testId: "nav-link-faq" },
];

const Header = ({ onBook, homePrefix = "" }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const closeMenu = () => setMobileOpen(false);

  return (
    <div className="site-top-stack" dir="ltr">
      <EmergencyAnnouncementBar />
      <header className="site-header">
        <div className="header-inner">
          <a className="brand-link" href={`${homePrefix}#top`} onClick={closeMenu} data-testid="header-brand-logo">
            <img src="/assets/logo-cropped.png" alt="MyEnglish Lesson.ca" className="brand-logo" />
          </a>
          <nav className="desktop-nav" aria-label="Primary navigation">
            {links.map((link) => (
              <a key={link.testId} href={`${homePrefix}${link.href}`} data-testid={link.testId}>
                {link.label}
              </a>
            ))}
          </nav>
          <div className="header-actions">
            <button className="button button-crimson header-book-button" type="button" onClick={onBook} data-testid="header-book-seat-button">
              Live Lessons - Learn Now
            </button>
            <button
              className="mobile-menu-toggle"
              type="button"
              aria-expanded={mobileOpen}
              aria-controls="mobile-navigation"
              aria-label={mobileOpen ? "Close navigation menu" : "Open navigation menu"}
              onClick={() => setMobileOpen((open) => !open)}
              data-testid="mobile-navigation-toggle"
            >
              {mobileOpen ? <X size={22} strokeWidth={2.2} /> : <Menu size={22} strokeWidth={2.2} />}
            </button>
          </div>
        </div>
        <nav id="mobile-navigation" className={`mobile-nav ${mobileOpen ? "is-open" : ""}`} aria-label="Mobile navigation" aria-hidden={!mobileOpen}>
          {links.map((link) => (
            <a key={link.testId} href={`${homePrefix}${link.href}`} onClick={closeMenu} data-testid={`${link.testId}-mobile`}>
              {link.label}
            </a>
          ))}
          <button className="button button-crimson mobile-book-button" type="button" onClick={() => { closeMenu(); onBook(); }} data-testid="mobile-book-seat-button">
            Live Lessons - Learn Now
          </button>
        </nav>
      </header>
    </div>
  );
};

export default Header;
